<button (click)="loginFusion()" class="btn btn-primary rounded">
  {{ 'login.page.login' | translate }}
</button>

<div class="mt-2">
  <fgbcl-errors></fgbcl-errors>
</div>
